import type { WebhookEventType } from "./webhook-events";

export const T = {
  en_GB: {
    name: "Name",
    url: "URL",
    events: "Events",
    status: "Status",
    actions: "Actions",
    edit: "Edit",
    active: "Active",
    inactive: "Inactive",
    autoDisabled: "Auto-disabled",
    logs: "Logs",
    test: "Test",
    testing: "Testing...",
    more: "more",
    noWebhooksYet:
      "No webhooks configured yet. Create your first webhook to start receiving event notifications.",
    deleteWebhook: "Delete Webhook",
    deleteConfirmation:
      "Are you sure you want to delete this webhook? This action cannot be undone and you will stop receiving event notifications to this endpoint.",
    cancel: "Cancel",
    deleting: "Deleting...",
    deleteWebhookAction: "Delete Webhook",
    error: "Error",
    failedToDeleteWebhook: "Failed to delete webhook",
    ok: "OK",
    testSent: "Test Sent",
    testSuccessDescription:
      "Test webhook sent successfully! Check the delivery logs to see the response.",
    failedToSendTestWebhook: "Failed to send test webhook",
  },
  nb_NO: {
    name: "Navn",
    url: "URL",
    events: "Hendelser",
    status: "Status",
    actions: "Handlinger",
    edit: "Rediger",
    active: "Aktiv",
    inactive: "Inaktiv",
    autoDisabled: "Deaktivert automatisk",
    logs: "Logger",
    test: "Test",
    testing: "Tester...",
    more: "mer",
    noWebhooksYet:
      "Ingen webhooks konfigurert ennå. Opprett din første webhook for å begynne å motta hendelsesvarslinger.",
    deleteWebhook: "Slett webhook",
    deleteConfirmation:
      "Er du sikker på at du vil slette denne webhooken? Denne handlingen kan ikke angres, og du vil slutte å motta hendelsesvarslinger til dette endepunktet.",
    cancel: "Avbryt",
    deleting: "Sletter...",
    deleteWebhookAction: "Slett webhook",
    error: "Feil",
    failedToDeleteWebhook: "Kunne ikke slette webhook",
    ok: "OK",
    testSent: "Test sendt",
    testSuccessDescription: "Test-webhook sendt! Sjekk leveringsloggene for å se svaret.",
    failedToSendTestWebhook: "Kunne ikke sende test-webhook",
  },
} as const;

/** Label of each webhook event. */
export const EVENTS = {
  en_GB: {
    "flow_instance.created": "Flow Instance Created",
    "flow_instance.submitted": "Flow Instance Submitted",
    "flow_instance.unlocked": "Flow Instance Unlocked",
    "flow_instance.cancelled": "Flow Instance Cancelled",
    "flow_instance.reopened": "Flow Instance Reopened",
    "flow_instance.completed": "Flow Instance Completed",
    "flow_instance.step_changed": "Process Step Changed",
    "client.created": "Client Created",
    "client.updated": "Client Updated",
    "client.deleted": "Client Deleted",
    "compliance.requested": "Compliance Approval Requested",
    "compliance.approved": "Compliance Approved",
    "compliance.rejected": "Compliance Rejected",
    "compliance.withdrawn": "Compliance Request Withdrawn",
    "external_approval.requested": "External Approval Requested",
    "external_approval.approved": "External Approval Granted",
    "external_approval.rejected": "External Approval Rejected",
    "external_approval.withdrawn": "External Approval Withdrawn",
    "signature_order.created": "Signature Order Created",
    "signature_order.cancelled": "Signature Order Cancelled",
    "signature_order.signed": "Signature Order Signed",
    "pdf.generated": "PDF Generated",
    "pdf.deleted": "PDF Deleted",
    "flow.created": "Flow Created",
    "flow.updated": "Flow Updated",
    "flow.activated": "Flow Activated",
    "flow.deactivated": "Flow Deactivated",
    "flow.deleted": "Flow Deleted",
  } satisfies Record<WebhookEventType, string>,
  nb_NO: {
    "flow_instance.created": "Flytinstans opprettet",
    "flow_instance.submitted": "Flytinstans sendt inn",
    "flow_instance.unlocked": "Flytinstans låst opp",
    "flow_instance.cancelled": "Flytinstans kansellert",
    "flow_instance.reopened": "Flytinstans gjenåpnet",
    "flow_instance.completed": "Flytinstans fullført",
    "flow_instance.step_changed": "Prosesstrinn endret",
    "client.created": "Kunde opprettet",
    "client.updated": "Kunde oppdatert",
    "client.deleted": "Kunde slettet",
    "compliance.requested": "Compliance-godkjenning forespurt",
    "compliance.approved": "Compliance godkjent",
    "compliance.rejected": "Compliance avvist",
    "compliance.withdrawn": "Compliance-forespørsel trukket",
    "external_approval.requested": "Ekstern godkjenning forespurt",
    "external_approval.approved": "Ekstern godkjenning gitt",
    "external_approval.rejected": "Ekstern godkjenning avvist",
    "external_approval.withdrawn": "Ekstern godkjenning trukket",
    "signature_order.created": "Signeringsordre opprettet",
    "signature_order.cancelled": "Signeringsordre kansellert",
    "signature_order.signed": "Signeringsordre signert",
    "pdf.generated": "PDF generert",
    "pdf.deleted": "PDF slettet",
    "flow.created": "Flyt opprettet",
    "flow.updated": "Flyt oppdatert",
    "flow.activated": "Flyt aktivert",
    "flow.deactivated": "Flyt deaktivert",
    "flow.deleted": "Flyt slettet",
  } satisfies Record<WebhookEventType, string>,
} as const;
